import { Card, CardActions, CardContent, CardHeader, IconButton, Modal, Theme, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { createStyles, makeStyles } from "@mui/styles";
import { LoadingButton } from '@mui/lab';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        modal: {
            position: 'fixed',
            border: '2px solid #000',
            borderRadius: "10px",
            boxShadow: theme.shadows[5],
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
        }
    }))

type CreateNewMinimumUsagePeriodsModalProps = {
    createNewMinimumUsagePeriodsModalOpen: boolean
    setCreateNewMinimumUsagePeriodsModalOpen: Function
    createNewMinimumUsagePeriods: Function
}


function CreateNewMinimumUsagePeriodsModal({ createNewMinimumUsagePeriodsModalOpen, setCreateNewMinimumUsagePeriodsModalOpen, createNewMinimumUsagePeriods }: CreateNewMinimumUsagePeriodsModalProps): JSX.Element {

    const classes = useStyles();

    async function confirmCreateNewMinimumUsagePeriods() {
        createNewMinimumUsagePeriods()
        setCreateNewMinimumUsagePeriodsModalOpen(false);
    }

    function handleAddNewMinimumUsagePeriodsModalClose() {
        setCreateNewMinimumUsagePeriodsModalOpen(false);
    }

    return (
        <Modal open={createNewMinimumUsagePeriodsModalOpen}
            onClose={handleAddNewMinimumUsagePeriodsModalClose}>
            <div className={classes.modal}>
                <Card>
                    <CardHeader
                        action={
                            <IconButton
                                color="primary"
                                onClick={handleAddNewMinimumUsagePeriodsModalClose}>
                                <CloseIcon />
                            </IconButton>}
                        title="Create new empty minimum usage periods" />

                    <CardContent>
                        <Typography>Please be aware this will overwrite any existing minimum usage periods on this subscription. Do you wish to continue?</Typography>
                    </CardContent>
                    <CardActions>
                        <LoadingButton
                            style={{ marginLeft: 'auto' }}
                            variant="contained"
                            color="primary"
                            onClick={confirmCreateNewMinimumUsagePeriods}>
                            CONTINUE
                        </LoadingButton>
                    </CardActions>
                </Card>
            </div>
        </Modal>);
}

export { CreateNewMinimumUsagePeriodsModal }
